import React from "react";
import { ProgressBar, Spinner } from "react-bootstrap";
import { Link } from "react-router-dom";
import "./HeaderUploadStatus.css";
import prettyBytes from "pretty-bytes";

export default function HeaderUploadStatus({
   onSkin,
   status,
   onCancel,
   progress,
   remainingFiles,
   remainingSize,
   remainingTime,
   uploadSpeed,
   error,
   totalUploaded,
   totalElapsedTime,
}) {
   const toggleSidebar = (e) => {
      e.preventDefault();
      let isOffset = document.body.classList.contains("sidebar-offset");
      if (isOffset) {
         document.body.classList.toggle("sidebar-show");
      } else {
         if (window.matchMedia("(max-width: 991px)").matches) {
            document.body.classList.toggle("sidebar-show");
         } else {
            document.body.classList.toggle("sidebar-hide");
         }
      }
   };

   return (
      <div className={`header-main-status ${status} d-flex px-3 px-lg-4`}>
         <div className="d-flex flex-grow-1 align-items-center">
            <div>
               <Link onClick={toggleSidebar} style={{ color: "#fff" }} className="menu-link me-3 me-lg-4">
                  <i className="ri-menu-2-fill"></i>
               </Link>
            </div>
            <div className="d-flex align-items-start ms-5 mt-2">
               {status === "status-uploading" && (
                  <>
                     <div className="spinner-column d-flex align-items-center me-2 mt-1">
                        <Spinner animation="border" size="sm" className="text-light" />
                     </div>
                     <div className="progress-container d-flex flex-column">
                        <div className="mb-1">Uploading</div>
                        <div className="d-flex align-items-center mb-1">
                           <ProgressBar now={progress} className="h-2 fixed-progress-bar" />
                           <span className="progress-percentage ms-4">{progress}%</span>
                        </div>
                        <div className="fs-xs pb-1">
                           Total Remaining {remainingFiles} files: {prettyBytes(remainingSize)} ({100 - progress}%)
                        </div>
                        <div className="fs-xs pb-1">Estimated time remaining {remainingTime} minutes</div>
                        <div className="fs-xs">Transfer rate {uploadSpeed} KB/s</div>
                     </div>
                  </>
               )}
               {status === "status-cancel" && (
                  <div className="d-flex flex-column">
                     <div className="h4 mb-1">Uploading Cancelled</div>
                     <div className="fs-sm">Total files not uploaded is {remainingFiles}</div>
                     <div className="fs-sm">Total of {totalUploaded} files that were successfully uploaded will be processed!</div>
                  </div>
               )}
               {status === "status-error" && (
                  <div className="d-flex flex-column">
                     <div className="h4 mb-1">Uploading Error</div>
                     <div className="fs-sm">The following error has occurred: {error}</div>
                  </div>
               )}
               {status === "status-success" && (
                  <div className="d-flex flex-column">
                     <div className="h4 mb-1">Uploading Completed</div>
                     <div className="fs-sm">
                        Total of {totalUploaded} files uploaded taking {totalElapsedTime}.
                     </div>
                  </div>
               )}
            </div>
         </div>
         <div className="ms-3 ms-xl-4 d-flex align-items-center">
            {status === "status-uploading" && (
               <button type="button" onClick={onCancel} className="btn btn-outline-light btn-cancel-upload pb-1 pt-1 ps-3 pe-3">
                  Cancel
               </button>
            )}
         </div>
      </div>
   );
}
